import LoginCard from '@/containers/LoginCard/LoginCard'
import { useAppStore } from '@/store/app'

const LoginPage = () => {
  const { customerServiceNumber } = useAppStore((state) => state)
  return (
    <div className="relative flex min-h-dvh">
      <div className="absolute inset-0 flex items-center justify-center">
        <LoginCard phoneNumber={customerServiceNumber} />
      </div>
    </div>
  )
}

export default LoginPage
